import { action, computed, makeObservable, observable } from 'mobx';
import { TimeZone } from '../models';

export class TimeZoneStore {
  @observable timeZonesMap = new Map<string, TimeZone>();

  constructor() {
    makeObservable(this);
  }

  @action
  setTimeZones(timeZones: TimeZone[]) {
    this.timeZonesMap.clear();
    timeZones.forEach((timeZone) => {
      this.timeZonesMap.set(timeZone.displayName, { ...timeZone });
    });
  }

  @computed
  get timeZones(): TimeZone[] {
    return Array.from(this.timeZonesMap.values());
  }
}
